import { SignupState } from "../../../../reducers/signup.reducer.types";

export const getCountries = (state: SignupState) => state.api.countries.items;
export const getCountriesIsFetching = (state: SignupState) =>
  state.api.countries.isFetchingCountries;
